import { generateIconComponent } from './icons.utils';

export const ChevronDownSolidIcon = generateIconComponent({
    name: 'ChevronDownSolidIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M0.322041 6.87877L1.87884 5.32203C2.30823 4.89266 3.00626 4.89266 3.43565 5.32203L11.9992 13.8874L20.5627 5.32203C20.9943 4.89266 21.6901 4.89266 22.1195 5.32203L23.6763 6.87877C24.1079 7.30814 24.1079 8.00615 23.6763 8.43552L13.556 18.5577C13.1442 18.9694 12.5827 19.2028 11.9992 19.2028C11.4156 19.2028 10.8563 18.9694 10.4424 18.5577L0.32204 8.43552C-0.107347 8.00615 -0.107347 7.30814 0.322041 6.87877Z" />
    ),
});
